import { CartUpdatedEvent } from '@theme/events';

// Upsell panier Birthstone : applique les corrections calculees par snippets/wk-upsell-guard.liquid
// (copie retiree sans le collier, quantite ramenee a 1). Une seule tentative par jeu de corrections.
const done = new Set();

class WkUpsellGuard extends HTMLElement {
  connectedCallback() {
    const raw = this.dataset.updates || '';
    const onCartPage = !!this.closest('cart-component');
    // Sur la page /cart, c'est la garde de la page qui agit (le drawer existe aussi).
    if (!onCartPage && document.querySelector('cart-component')) return;
    if (!raw || done.has(raw)) return;
    done.add(raw);

    const updates = {};
    raw.split(',').filter(Boolean).forEach((pair) => {
      const i = pair.lastIndexOf('=');
      updates[pair.slice(0, i)] = parseInt(pair.slice(i + 1), 10);
    });

    const drawer = document.querySelector('cart-drawer');
    const body = { updates };
    if (drawer && !onCartPage) body.sections = drawer.dataset.sectionId;

    fetch(Theme.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((cart) => {
        if (!cart || !Array.isArray(cart.items)) return;
        if (onCartPage) {
          window.location.reload();
          return;
        }
        document.dispatchEvent(
          new CartUpdatedEvent({}, { itemCount: cart.item_count, source: 'wk-upsell-guard', sections: cart.sections }),
        );
      })
      .catch((e) => console.error(e));
  }
}

if (!customElements.get('wk-upsell-guard')) customElements.define('wk-upsell-guard', WkUpsellGuard);
